import React, { useContext, useEffect, useState, useRef } from "react";
import '../css/style.css';
import { useNavigate } from "react-router-dom";
import { DataContext } from "./DataContext";
import { format, parseISO, isAfter } from "date-fns";
import Modal from 'bootstrap/js/dist/modal';

const EventModal = () => {
    const { events, fetchEvents } = useContext(DataContext); // fetchEvents added
    const modalRef = useRef(null);
    const navigate = useNavigate();
    const [randomImage, setRandomImage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
   /* console.log("DID" + events)*/
    // Import images dynamically
    const importAll = (r) => r.keys().map(r);
    const images = importAll(require.context("../images/image-rotate/", false, /\.(png|jpe?g|svg|webp)$/));

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * images.length);
        setRandomImage(images[randomIndex]);
    }, []);

    // Fetch events if not already loaded
    useEffect(() => {
        let didCancel = false;

        const loadEvents = async () => {
            setIsLoading(true);
            try {
                await fetchEvents();
            } catch (err) {
                console.error("Error fetching events", err);
            } finally {
                if (!didCancel) setIsLoading(false);
            }
        };

        loadEvents();

        return () => {
            didCancel = true; // cleanup so setState won't fire after unmount
        };
    }, []); // 👈 empty array means run once


    // Show modal after 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            if (modalRef.current && events && events.length > 0) {
                const myModal = new Modal(modalRef.current);
                myModal.show();
            }
        }, 2000);
        return () => clearTimeout(timer);
    }, [events]);

    const goToSchedule = () => {
        navigate("/Calendar");
    };

    if (isLoading) {
        return <p>Loading events...</p>;
    }

    if (!events || events.length === 0) {
        return <p>No events available.</p>;
    }

    // Find the next upcoming event
    const now = new Date();
    const nextEvent = events.find(event => isAfter(parseISO(event.start_time), now));

    if (!nextEvent) {
        return <p>No upcoming events found.</p>;
    }

    const eventDate = parseISO(nextEvent.start_time);
    const formattedDate = format(eventDate, "MMMM d, yyyy");
    const formattedTime = format(eventDate, "hh:mm a");

    return (
        <div>
            <div id="myModal" ref={modalRef} className="modal fade" tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2>Join us on our next voyage!</h2>

                            <a href="https://www.facebook.com/DYSYachtRock" target="_blank" rel="noopener noreferrer" className="btn social-link-face">
                                <i className="fab fa-facebook-f me-2"></i>Facebook
                            </a>
                            <a href="https://www.instagram.com/dirtyyachtin/" target="_blank" rel="noopener noreferrer" className="btn social-link-insta">
                                <i className="fab fa-instagram me-2"></i>Instagram
                            </a>
                        </div>
                        <div className="modal-body">
                            <address>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                <div id="eventName"><b>Location:</b> {nextEvent.name}</div>
                                <div id="eventDate"><b>Date:</b> {formattedDate}</div>
                                <div id="eventTime"><b>Time:</b> {formattedTime}</div>
                                <div id="eventAddress"><b>Address:</b> {nextEvent.place?.name}</div>
                                <button type="button" className="btn btn-secondary mt-3" onClick={goToSchedule} data-bs-dismiss="modal">See our Schedule</button>
                            </address>
                            <img src={randomImage} id="bandImage1" className="bandImages" alt="Yacht Rock Band - Dirty Yachtin Scoundrels" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventModal;
